import { useEffect, useState } from 'react';
import { API_URL } from '../api';
import { CLASSIC_GYM, TEMPLATES } from './templates';
import type { ZoneTemplate } from './types';

// Resolve a layout reference to a ZoneTemplate. A built-in key (e.g.
// 'classic-gym-board') resolves locally; anything else is treated as a
// saved-layout UUID and fetched from /api/layouts/public/:id.
export function useResolvedTemplate(
  idOrKey: string | undefined,
): ZoneTemplate {
  const builtIn = idOrKey ? TEMPLATES[idOrKey] : undefined;
  const [fetched, setFetched] = useState<ZoneTemplate | null>(null);

  useEffect(() => {
    if (!idOrKey || builtIn) {
      setFetched(null);
      return;
    }
    let cancelled = false;
    fetch(`${API_URL}/api/layouts/public/${encodeURIComponent(idOrKey)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (!cancelled && j) {
          setFetched({
            id: j.id,
            name: j.name,
            aspectRatio: j.aspectRatio,
            zones: j.zones,
            bindings: j.bindings,
            background: j.background ?? undefined,
            theme: j.theme ?? undefined,
          });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [idOrKey, builtIn]);

  return builtIn ?? fetched ?? CLASSIC_GYM;
}
